import React, { useContext } from 'react';
import { ModalContext } from '../ModalContext';

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

/**
 * ModalButton connects directly to the parent Modal. When you click the button,
 * it'll trigger the Modal's onClose function.
 *
 * This allows for the Modal to completely handle its open/close state, versus
 * externally.
 */
export const ModalCloseButton: React.FC<Props> = ({ children, onClick, ...rest }) => {
  const modalContext = useContext(ModalContext);

  const onButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    modalContext.onClose?.(); // eslint-disable-line no-unused-expressions
    onClick?.(event); // eslint-disable-line no-unused-expressions
  };

  return (
    <button {...rest} type="button" onClick={onButtonClick}>
      {children}
    </button>
  );
};
